import { render, staticRenderFns } from "./PoveznicaDataEdit.vue?vue&type=template&id=75cf2da0&scoped=true&"
import script from "./PoveznicaDataEdit.vue?vue&type=script&lang=js&"
export * from "./PoveznicaDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cf2da0",
  null
  
)

export default component.exports